import Logo from "../../Components/Logo";
import styles from "./index.module.css";
import {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import UserContext from "../../store/UserStore/context";
import { useNavigate } from "react-router-dom";
import { DataForm } from "./Greetings";
import { PaymentStage } from "./PaymentStage";

export default function PaymentForm() {
  const [stage, setStage] = useState("details");
  const [details, setDetails] = useState(null);
  const containerRef = useRef(null);
  const context = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!context.store.user || !context.store.user.testResult)
      return navigate("/");
  }, [context.store.user, navigate]);

  useLayoutEffect(() => {
    document.body.style.padding = "0";
    document.body.style.margin = "0";
    document.body.style.backgroundColor = "#0A2294";
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    if (containerRef.current) containerRef.current.scrollTop = 0;
  }, [stage]);

  return (
    <div
      className={[
        styles.container,
        stage === "payment" ? styles.paymentMode : "",
      ].join(" ")}
      ref={containerRef}
    >
      <Logo white />
      <div className={styles.content}>
        <div
          className={[
            styles.greetings,
            styles.intro,
            stage === "payment" ? styles.paymentIntro : "",
          ].join(" ")}
        >
          {stage === "details" ? (
            <DataForm
              onContinue={(formDetails) => {
                setDetails(formDetails);
                setStage("payment");
              }}
            />
          ) : (
            <PaymentStage details={details} />
          )}
        </div>
      </div>
    </div>
  );
}
